module.exports = __webpack_public_path__ + "img/inbox-selected.9624e36c.svg";